import { useState } from "react";
import Button from "../Button/Button";
import Checkbox from "../Checkbox/Checkbox";
import Modal, { ModalProps } from "../Modal/Modal";
import ModalTitle from "../Modal/ModalTitle";
import { useSetTermsAndConditions } from "@/shared/atoms/useTermsAndConditionsAtom";
import { useSetModal } from "@/shared/atoms/useModal";

const TermsAndConditionsModal = ({ onExit, ...props }: ModalProps) => {
  const [checked, setChecked] = useState(false);
  const setTermsAndConditions = useSetTermsAndConditions();
  const setModal = useSetModal();

  return (
    <Modal width="50rem" {...props}>
      <ModalTitle>Terms & Conditions</ModalTitle>
      <p className="mt-[2rem]">
        Please read and accept our Terms and Conditions to continue.
      </p>
      <a target="_blank" rel="noopener noreferrer" href="/terms-conditions">
        Read Terms & Conditions
      </a>
      <div className="mt-[2rem]">
        <Checkbox
          active={checked}
          onClick={() => setChecked(!checked)}
          checked={checked}
        >
          <span>I agree to the Terms & Conditions</span>
        </Checkbox>
      </div>

      <div className="mt-[2rem]">
        <Button
          type="button"
          isDisabled={!checked}
          style={{ width: "100%" }}
          onClick={() => {
            setTermsAndConditions(true);
            setModal("", {});
          }}
        >
          Accept
        </Button>
      </div>
    </Modal>
  );
};

export default TermsAndConditionsModal;
